<template>
  <b-card :title="$t('common.Educations')">
    <div>
      <b-form ref="form">
        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in educations"
          :id="item.id"
          :key="item.id"
          ref="row"
        >
          <!-- Item Name -->
          <b-col cols="12" md="3">
            <b-form-group :label="$t('common.Degree')" label-for="degree">
              <b-form-input
                id="degree"
                v-model="item.degree"
                type="text"
                :placeholder="$t('common.Degree')"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group
              :label="$t('common.University')"
              label-for="university"
            >
              <b-form-input
                id="university"
                v-model="item.institute"
                type="text"
                :placeholder="$t('common.University')"
              />
            </b-form-group>
          </b-col>
          <!--country-->
          <b-col cols="12" md="2">
            <b-form-group :label="$t('common.Country')">
              <v-select
                v-model="item.location"
                :placeholder="$t('common.Country')"
                label="text"
                :options="countries"
                style="color: black"
              />
            </b-form-group>
          </b-col>
          <!-- Date -->
          <b-col cols="12" md="3">
            <label for="Degree-Date">{{ $t("common.Date") }}</label>
            <b-form-datepicker
              v-model="item.date"
              class="mb-1"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              :locale="$store.state.locale.locale"
            />
          </b-col>
          <!-- Remove Button -->
          <b-col cols="12" md="1" class="pt-2 mt-0 mb-60">
            <b-button
              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
              variant="outline-danger"
              class="mt-0"
              @click="removeItem(index)"
            >
              <feather-icon icon="XIcon" class="mr-25" />
              <span></span>
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>
      </b-form>
    </div>

    <b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="repeateAgain"
    >
      <feather-icon icon="PlusIcon" class="mr-25" />
      <span>{{ $t("common.AddNew") }}</span>
    </b-button>
  </b-card>
</template>

<script>
import BCardCode from "@core/components/b-card-code";
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BCard,
  BFormRating,
  BFormDatepicker,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
  components: {
    BCardCode,
    BCard,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormRating,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: ["educations"],
  data() {
    return {
      nextTodoId: 2,
      location: {},
      Degree: "",
      date: "",
    };
  },
  computed: {
    ...mapGetters({
      countries: "country/getCountries",
    }),
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.fetchCountries();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    ...mapActions({
      fetchCountries: "country/retreiveCountries",
    }),
    repeateAgain() {
      this.educations.push({
        id: (this.nextTodoId += this.nextTodoId),
        location: this.location.value,
        certDate: this.certDate,
        certificate: this.certificate,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.educations.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
